import React from 'react';

// Style
import './ListSupplierLogo.scss';

// ClassName
import clsx from 'clsx';

// Link
import { Link } from 'react-router-dom';

// Lib
import { decodeHtmlEntity } from 'lib/helpers';

// Components
import Img from 'components/Img';

// Actions
import { Supplier } from 'pages/MoleculeProduct/reducer';

// Constants
import { suppliersConfig } from 'constans/prices';

// Type
type SupplierKey = keyof typeof suppliersConfig;

// Interface
interface IListSupplierLogo {
	data: Supplier[];
	className?: string,
	classNameText?: string,
	classNameLogo?: string,
	isHiddeBorder?: boolean,
	classNameWrapperLogo?: string,
}

export const ListSupplierLogo: React.FC<IListSupplierLogo> = (props) => {
	const {
		data = [],
		className = '',
		isHiddeBorder = false,
		classNameText = '',
		classNameLogo = '',
		classNameWrapperLogo = ''
	} = props;

	const handlerRedirectToChemProbes = (url: string): void => {
		window.open(url, '_blank');
	};

	const cnMain = clsx(
		'list-supplier-logo flex flex-ai-center',
		className ? className : '',
	);

	const cnText = clsx(
		'list-supplier-logo__text mr5',
		classNameText ? classNameText : ''
	);

	const list: React.ReactNode | React.ReactNode[] = data?.length
		? data.map((item, i) => {
			const div = document.createElement('div');
			div.innerHTML = item?.supId || '';
			const to = `${window.location.origin}/molecule-product/${div.innerText}`;

			const supplier = item.supplier as SupplierKey;
			const config = suppliersConfig[supplier];
			const handlerClickLogo = config?.isLink && supplier === config?.type
				? () => handlerRedirectToChemProbes(`${config.url}${item.supId}`)
				: () => {};
			const currentClassName = config?.isLink && supplier === config?.type
				? 'list-supplier-logo__chemical-probes'
				: '';
			const isNotLast = i < data?.length - 1;
			const cnLogo = clsx(
				`${config.className}`,
				classNameLogo ? classNameLogo : ''
			);
			return <div key={crypto.randomUUID()} className={cnMain}>
				{supplier === 'EBC' && <Link
					to={to}
					target="_blank"
					className={cnText}
					dangerouslySetInnerHTML={{ __html: decodeHtmlEntity(item?.supId || '') }}
				/>}

				{supplier !== 'EBC' && supplier !== 'CHEM_PROBE' && <p className={cnText}>{item?.supId}</p>}

				{supplier !== 'CHEM_PROBE' &&
					<div className={classNameWrapperLogo ? classNameWrapperLogo : ''}>
						<Img
							isSvg
							className={cnLogo}
							name={config?.icon}
						/>
					</div>
				}

				{supplier === 'CHEM_PROBE' && <div
					onClick={handlerClickLogo}
					className={`${currentClassName} ${classNameWrapperLogo ? classNameWrapperLogo : ''}`}
				>
					<Img
						isSvg
						withoutLoader
						className={cnLogo}
						name={config?.icon}
					/>
				</div>}
				{!isHiddeBorder && isNotLast && <p className={cnText}>|</p>}
			</div>;
		})
		: <></>;

	return <>{list}</>;
};

export default ListSupplierLogo;
